/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedDevRouteImport } from './routes/_authenticated/dev'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as InviteTokenRouteImport } from './routes/invite.$token'
import { Route as QTokenRouteImport } from './routes/q.$token'
import { Route as ShareSampleRouteImport } from './routes/share.sample'
import { Route as SignInSplatRouteImport } from './routes/sign-in.$'
import { Route as SignUpSplatRouteImport } from './routes/sign-up.$'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin/index'
import { Route as AuthenticatedAdminDebugRouteImport } from './routes/_authenticated/admin/debug'
import { Route as AuthenticatedAdminDeletionsRouteImport } from './routes/_authenticated/admin/deletions'
import { Route as AuthenticatedAdminDesignRouteImport } from './routes/_authenticated/admin/design'
import { Route as AuthenticatedDevDemosRouteImport } from './routes/_authenticated/dev/demos'
import { Route as AuthenticatedInteriorPackagesIdRouteImport } from './routes/_authenticated/interior-packages/$id'
import { Route as AuthenticatedSettingsAccountRouteImport } from './routes/_authenticated/settings/account'
import { Route as AuthenticatedSettingsBillingRouteImport } from './routes/_authenticated/settings/billing'
import { Route as AuthenticatedSettingsClientsRouteImport } from './routes/_authenticated/settings/clients'
import { Route as AuthenticatedSettingsCompanyRouteImport } from './routes/_authenticated/settings/company'
import { Route as AuthenticatedSettingsGeneralRouteImport } from './routes/_authenticated/settings/general'
import { Route as AuthenticatedSettingsInteriorPackagesRouteImport } from './routes/_authenticated/settings/interior-packages'
import { Route as AuthenticatedSettingsMaterialLibraryRouteImport } from './routes/_authenticated/settings/material-library'
import { Route as AuthenticatedSettingsProjectsRouteImport } from './routes/_authenticated/settings/projects'
import { Route as AuthenticatedSettingsQrSheetsRouteImport } from './routes/_authenticated/settings/qr-sheets'
import { Route as AuthenticatedSettingsTemplatesRouteImport } from './routes/_authenticated/settings/templates'
import { Route as AuthenticatedSettingsUsersRouteImport } from './routes/_authenticated/settings/users'
import { Route as PrintProjectsProjectIdRouteImport } from './routes/print.projects.$projectId'
import { Route as PrintTokenTokenRouteImport } from './routes/print.token.$token'
import { Route as ShareSelectionsTokenRouteImport } from './routes/share.selections.$token'
import { Route as AuthenticatedAdminAccountsIdRouteImport } from './routes/_authenticated/admin/accounts/$id'
import { Route as AuthenticatedProjectsIdIndexRouteImport } from './routes/_authenticated/projects/$id/index'
import { Route as AuthenticatedProjectsIdSelectionsRouteImport } from './routes/_authenticated/projects/$id/selections'
import { Route as AuthenticatedSettingsAccountNotificationsRouteImport } from './routes/_authenticated/settings/account/notifications'
import { Route as AuthenticatedSettingsDevDemosRouteImport } from './routes/_authenticated/settings/dev/demos'
import { Route as AuthenticatedSettingsDevJwtRouteImport } from './routes/_authenticated/settings/dev/jwt'
import { Route as AuthenticatedSettingsProjectsArchivedRouteImport } from './routes/_authenticated/settings/projects/archived'
import { Route as AuthenticatedSettingsUsersIdRouteImport } from './routes/_authenticated/settings/users/$id'
import { Route as AuthenticatedSettingsAccountProfileIndexRouteImport } from './routes/_authenticated/settings/account/profile.index'
import { Route as AuthenticatedSettingsAccountProfileSplatRouteImport } from './routes/_authenticated/settings/account/profile.$'
import { Route as AuthenticatedSettingsDevDemosAvatarFallbacksRouteImport } from './routes/_authenticated/settings/dev/demos/avatar-fallbacks'
import { Route as AuthenticatedSettingsDevDemosBrandRouteImport } from './routes/_authenticated/settings/dev/demos/brand'
import { Route as AuthenticatedSettingsDevDemosPlacesAutocompleteRouteImport } from './routes/_authenticated/settings/dev/demos/places-autocomplete'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDevRoute = AuthenticatedDevRouteImport.update({
  id: '/dev',
  path: '/dev',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const QTokenRoute = QTokenRouteImport.update({
  id: '/q/$token',
  path: '/q/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const ShareSampleRoute = ShareSampleRouteImport.update({
  id: '/share/sample',
  path: '/share/sample',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInSplatRoute = SignInSplatRouteImport.update({
  id: '/sign-in/$',
  path: '/sign-in/$',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpSplatRoute = SignUpSplatRouteImport.update({
  id: '/sign-up/$',
  path: '/sign-up/$',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedAdminRoute,
} as any)
const AuthenticatedAdminDebugRoute = AuthenticatedAdminDebugRouteImport.update({
  id: '/debug',
  path: '/debug',
  getParentRoute: () => AuthenticatedAdminRoute,
} as any)
const AuthenticatedAdminDeletionsRoute =
  AuthenticatedAdminDeletionsRouteImport.update({
    id: '/deletions',
    path: '/deletions',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminDesignRoute =
  AuthenticatedAdminDesignRouteImport.update({
    id: '/design',
    path: '/design',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedDevDemosRoute = AuthenticatedDevDemosRouteImport.update({
  id: '/demos',
  path: '/demos',
  getParentRoute: () => AuthenticatedDevRoute,
} as any)
const AuthenticatedInteriorPackagesIdRoute =
  AuthenticatedInteriorPackagesIdRouteImport.update({
    id: '/interior-packages/$id',
    path: '/interior-packages/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsAccountRoute =
  AuthenticatedSettingsAccountRouteImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsBillingRoute =
  AuthenticatedSettingsBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsClientsRoute =
  AuthenticatedSettingsClientsRouteImport.update({
    id: '/clients',
    path: '/clients',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsCompanyRoute =
  AuthenticatedSettingsCompanyRouteImport.update({
    id: '/company',
    path: '/company',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsGeneralRoute =
  AuthenticatedSettingsGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsInteriorPackagesRoute =
  AuthenticatedSettingsInteriorPackagesRouteImport.update({
    id: '/interior-packages',
    path: '/interior-packages',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsMaterialLibraryRoute =
  AuthenticatedSettingsMaterialLibraryRouteImport.update({
    id: '/material-library',
    path: '/material-library',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsProjectsRoute =
  AuthenticatedSettingsProjectsRouteImport.update({
    id: '/projects',
    path: '/projects',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsQrSheetsRoute =
  AuthenticatedSettingsQrSheetsRouteImport.update({
    id: '/qr-sheets',
    path: '/qr-sheets',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsTemplatesRoute =
  AuthenticatedSettingsTemplatesRouteImport.update({
    id: '/templates',
    path: '/templates',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsUsersRoute =
  AuthenticatedSettingsUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const PrintProjectsProjectIdRoute = PrintProjectsProjectIdRouteImport.update({
  id: '/print/projects/$projectId',
  path: '/print/projects/$projectId',
  getParentRoute: () => rootRouteImport,
} as any)
const PrintTokenTokenRoute = PrintTokenTokenRouteImport.update({
  id: '/print/token/$token',
  path: '/print/token/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const ShareSelectionsTokenRoute = ShareSelectionsTokenRouteImport.update({
  id: '/share/selections/$token',
  path: '/share/selections/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAdminAccountsIdRoute =
  AuthenticatedAdminAccountsIdRouteImport.update({
    id: '/accounts/$id',
    path: '/accounts/$id',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedProjectsIdIndexRoute =
  AuthenticatedProjectsIdIndexRouteImport.update({
    id: '/projects/$id/',
    path: '/projects/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProjectsIdSelectionsRoute =
  AuthenticatedProjectsIdSelectionsRouteImport.update({
    id: '/projects/$id/selections',
    path: '/projects/$id/selections',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsAccountNotificationsRoute =
  AuthenticatedSettingsAccountNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedSettingsAccountRoute,
  } as any)
const AuthenticatedSettingsDevDemosRoute =
  AuthenticatedSettingsDevDemosRouteImport.update({
    id: '/dev/demos',
    path: '/dev/demos',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsDevJwtRoute =
  AuthenticatedSettingsDevJwtRouteImport.update({
    id: '/dev/jwt',
    path: '/dev/jwt',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsProjectsArchivedRoute =
  AuthenticatedSettingsProjectsArchivedRouteImport.update({
    id: '/archived',
    path: '/archived',
    getParentRoute: () => AuthenticatedSettingsProjectsRoute,
  } as any)
const AuthenticatedSettingsUsersIdRoute =
  AuthenticatedSettingsUsersIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedSettingsUsersRoute,
  } as any)
const AuthenticatedSettingsAccountProfileIndexRoute =
  AuthenticatedSettingsAccountProfileIndexRouteImport.update({
    id: '/profile/',
    path: '/profile/',
    getParentRoute: () => AuthenticatedSettingsAccountRoute,
  } as any)
const AuthenticatedSettingsAccountProfileSplatRoute =
  AuthenticatedSettingsAccountProfileSplatRouteImport.update({
    id: '/profile/$',
    path: '/profile/$',
    getParentRoute: () => AuthenticatedSettingsAccountRoute,
  } as any)
const AuthenticatedSettingsDevDemosAvatarFallbacksRoute =
  AuthenticatedSettingsDevDemosAvatarFallbacksRouteImport.update({
    id: '/avatar-fallbacks',
    path: '/avatar-fallbacks',
    getParentRoute: () => AuthenticatedSettingsDevDemosRoute,
  } as any)
const AuthenticatedSettingsDevDemosBrandRoute =
  AuthenticatedSettingsDevDemosBrandRouteImport.update({
    id: '/brand',
    path: '/brand',
    getParentRoute: () => AuthenticatedSettingsDevDemosRoute,
  } as any)
const AuthenticatedSettingsDevDemosPlacesAutocompleteRoute =
  AuthenticatedSettingsDevDemosPlacesAutocompleteRouteImport.update({
    id: '/places-autocomplete',
    path: '/places-autocomplete',
    getParentRoute: () => AuthenticatedSettingsDevDemosRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AuthenticatedAdminRouteWithChildren
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/dev': typeof AuthenticatedDevRouteWithChildren
  '/settings': typeof AuthenticatedSettingsRouteWithChildren
  '/invite/$token': typeof InviteTokenRoute
  '/q/$token': typeof QTokenRoute
  '/share/sample': typeof ShareSampleRoute
  '/sign-in/$': typeof SignInSplatRoute
  '/sign-up/$': typeof SignUpSplatRoute
  '/admin/debug': typeof AuthenticatedAdminDebugRoute
  '/admin/deletions': typeof AuthenticatedAdminDeletionsRoute
  '/admin/design': typeof AuthenticatedAdminDesignRoute
  '/dev/demos': typeof AuthenticatedDevDemosRoute
  '/interior-packages/$id': typeof AuthenticatedInteriorPackagesIdRoute
  '/settings/account': typeof AuthenticatedSettingsAccountRouteWithChildren
  '/settings/billing': typeof AuthenticatedSettingsBillingRoute
  '/settings/clients': typeof AuthenticatedSettingsClientsRoute
  '/settings/company': typeof AuthenticatedSettingsCompanyRoute
  '/settings/general': typeof AuthenticatedSettingsGeneralRoute
  '/settings/interior-packages': typeof AuthenticatedSettingsInteriorPackagesRoute
  '/settings/material-library': typeof AuthenticatedSettingsMaterialLibraryRoute
  '/settings/projects': typeof AuthenticatedSettingsProjectsRouteWithChildren
  '/settings/qr-sheets': typeof AuthenticatedSettingsQrSheetsRoute
  '/settings/templates': typeof AuthenticatedSettingsTemplatesRoute
  '/settings/users': typeof AuthenticatedSettingsUsersRouteWithChildren
  '/print/projects/$projectId': typeof PrintProjectsProjectIdRoute
  '/print/token/$token': typeof PrintTokenTokenRoute
  '/share/selections/$token': typeof ShareSelectionsTokenRoute
  '/admin/': typeof AuthenticatedAdminIndexRoute
  '/admin/accounts/$id': typeof AuthenticatedAdminAccountsIdRoute
  '/projects/$id/selections': typeof AuthenticatedProjectsIdSelectionsRoute
  '/settings/account/notifications': typeof AuthenticatedSettingsAccountNotificationsRoute
  '/settings/dev/demos': typeof AuthenticatedSettingsDevDemosRouteWithChildren
  '/settings/dev/jwt': typeof AuthenticatedSettingsDevJwtRoute
  '/settings/projects/archived': typeof AuthenticatedSettingsProjectsArchivedRoute
  '/settings/users/$id': typeof AuthenticatedSettingsUsersIdRoute
  '/projects/$id/': typeof AuthenticatedProjectsIdIndexRoute
  '/settings/account/profile/$': typeof AuthenticatedSettingsAccountProfileSplatRoute
  '/settings/dev/demos/avatar-fallbacks': typeof AuthenticatedSettingsDevDemosAvatarFallbacksRoute
  '/settings/dev/demos/brand': typeof AuthenticatedSettingsDevDemosBrandRoute
  '/settings/dev/demos/places-autocomplete': typeof AuthenticatedSettingsDevDemosPlacesAutocompleteRoute
  '/settings/account/profile/': typeof AuthenticatedSettingsAccountProfileIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/dev': typeof AuthenticatedDevRouteWithChildren
  '/settings': typeof AuthenticatedSettingsRouteWithChildren
  '/invite/$token': typeof InviteTokenRoute
  '/q/$token': typeof QTokenRoute
  '/share/sample': typeof ShareSampleRoute
  '/sign-in/$': typeof SignInSplatRoute
  '/sign-up/$': typeof SignUpSplatRoute
  '/admin/debug': typeof AuthenticatedAdminDebugRoute
  '/admin/deletions': typeof AuthenticatedAdminDeletionsRoute
  '/admin/design': typeof AuthenticatedAdminDesignRoute
  '/dev/demos': typeof AuthenticatedDevDemosRoute
  '/interior-packages/$id': typeof AuthenticatedInteriorPackagesIdRoute
  '/settings/account': typeof AuthenticatedSettingsAccountRouteWithChildren
  '/settings/billing': typeof AuthenticatedSettingsBillingRoute
  '/settings/clients': typeof AuthenticatedSettingsClientsRoute
  '/settings/company': typeof AuthenticatedSettingsCompanyRoute
  '/settings/general': typeof AuthenticatedSettingsGeneralRoute
  '/settings/interior-packages': typeof AuthenticatedSettingsInteriorPackagesRoute
  '/settings/material-library': typeof AuthenticatedSettingsMaterialLibraryRoute
  '/settings/projects': typeof AuthenticatedSettingsProjectsRouteWithChildren
  '/settings/qr-sheets': typeof AuthenticatedSettingsQrSheetsRoute
  '/settings/templates': typeof AuthenticatedSettingsTemplatesRoute
  '/settings/users': typeof AuthenticatedSettingsUsersRouteWithChildren
  '/print/projects/$projectId': typeof PrintProjectsProjectIdRoute
  '/print/token/$token': typeof PrintTokenTokenRoute
  '/share/selections/$token': typeof ShareSelectionsTokenRoute
  '/admin': typeof AuthenticatedAdminIndexRoute
  '/admin/accounts/$id': typeof AuthenticatedAdminAccountsIdRoute
  '/projects/$id/selections': typeof AuthenticatedProjectsIdSelectionsRoute
  '/settings/account/notifications': typeof AuthenticatedSettingsAccountNotificationsRoute
  '/settings/dev/demos': typeof AuthenticatedSettingsDevDemosRouteWithChildren
  '/settings/dev/jwt': typeof AuthenticatedSettingsDevJwtRoute
  '/settings/projects/archived': typeof AuthenticatedSettingsProjectsArchivedRoute
  '/settings/users/$id': typeof AuthenticatedSettingsUsersIdRoute
  '/projects/$id': typeof AuthenticatedProjectsIdIndexRoute
  '/settings/account/profile/$': typeof AuthenticatedSettingsAccountProfileSplatRoute
  '/settings/dev/demos/avatar-fallbacks': typeof AuthenticatedSettingsDevDemosAvatarFallbacksRoute
  '/settings/dev/demos/brand': typeof AuthenticatedSettingsDevDemosBrandRoute
  '/settings/dev/demos/places-autocomplete': typeof AuthenticatedSettingsDevDemosPlacesAutocompleteRoute
  '/settings/account/profile': typeof AuthenticatedSettingsAccountProfileIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_authenticated/admin': typeof AuthenticatedAdminRouteWithChildren
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/dev': typeof AuthenticatedDevRouteWithChildren
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteWithChildren
  '/invite/$token': typeof InviteTokenRoute
  '/q/$token': typeof QTokenRoute
  '/share/sample': typeof ShareSampleRoute
  '/sign-in/$': typeof SignInSplatRoute
  '/sign-up/$': typeof SignUpSplatRoute
  '/_authenticated/admin/debug': typeof AuthenticatedAdminDebugRoute
  '/_authenticated/admin/deletions': typeof AuthenticatedAdminDeletionsRoute
  '/_authenticated/admin/design': typeof AuthenticatedAdminDesignRoute
  '/_authenticated/dev/demos': typeof AuthenticatedDevDemosRoute
  '/_authenticated/interior-packages/$id': typeof AuthenticatedInteriorPackagesIdRoute
  '/_authenticated/settings/account': typeof AuthenticatedSettingsAccountRouteWithChildren
  '/_authenticated/settings/billing': typeof AuthenticatedSettingsBillingRoute
  '/_authenticated/settings/clients': typeof AuthenticatedSettingsClientsRoute
  '/_authenticated/settings/company': typeof AuthenticatedSettingsCompanyRoute
  '/_authenticated/settings/general': typeof AuthenticatedSettingsGeneralRoute
  '/_authenticated/settings/interior-packages': typeof AuthenticatedSettingsInteriorPackagesRoute
  '/_authenticated/settings/material-library': typeof AuthenticatedSettingsMaterialLibraryRoute
  '/_authenticated/settings/projects': typeof AuthenticatedSettingsProjectsRouteWithChildren
  '/_authenticated/settings/qr-sheets': typeof AuthenticatedSettingsQrSheetsRoute
  '/_authenticated/settings/templates': typeof AuthenticatedSettingsTemplatesRoute
  '/_authenticated/settings/users': typeof AuthenticatedSettingsUsersRouteWithChildren
  '/print/projects/$projectId': typeof PrintProjectsProjectIdRoute
  '/print/token/$token': typeof PrintTokenTokenRoute
  '/share/selections/$token': typeof ShareSelectionsTokenRoute
  '/_authenticated/admin/': typeof AuthenticatedAdminIndexRoute
  '/_authenticated/admin/accounts/$id': typeof AuthenticatedAdminAccountsIdRoute
  '/_authenticated/projects/$id/selections': typeof AuthenticatedProjectsIdSelectionsRoute
  '/_authenticated/settings/account/notifications': typeof AuthenticatedSettingsAccountNotificationsRoute
  '/_authenticated/settings/dev/demos': typeof AuthenticatedSettingsDevDemosRouteWithChildren
  '/_authenticated/settings/dev/jwt': typeof AuthenticatedSettingsDevJwtRoute
  '/_authenticated/settings/projects/archived': typeof AuthenticatedSettingsProjectsArchivedRoute
  '/_authenticated/settings/users/$id': typeof AuthenticatedSettingsUsersIdRoute
  '/_authenticated/projects/$id/': typeof AuthenticatedProjectsIdIndexRoute
  '/_authenticated/settings/account/profile/$': typeof AuthenticatedSettingsAccountProfileSplatRoute
  '/_authenticated/settings/dev/demos/avatar-fallbacks': typeof AuthenticatedSettingsDevDemosAvatarFallbacksRoute
  '/_authenticated/settings/dev/demos/brand': typeof AuthenticatedSettingsDevDemosBrandRoute
  '/_authenticated/settings/dev/demos/places-autocomplete': typeof AuthenticatedSettingsDevDemosPlacesAutocompleteRoute
  '/_authenticated/settings/account/profile/': typeof AuthenticatedSettingsAccountProfileIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/dashboard'
    | '/dev'
    | '/settings'
    | '/invite/$token'
    | '/q/$token'
    | '/share/sample'
    | '/sign-in/$'
    | '/sign-up/$'
    | '/admin/debug'
    | '/admin/deletions'
    | '/admin/design'
    | '/dev/demos'
    | '/interior-packages/$id'
    | '/settings/account'
    | '/settings/billing'
    | '/settings/clients'
    | '/settings/company'
    | '/settings/general'
    | '/settings/interior-packages'
    | '/settings/material-library'
    | '/settings/projects'
    | '/settings/qr-sheets'
    | '/settings/templates'
    | '/settings/users'
    | '/print/projects/$projectId'
    | '/print/token/$token'
    | '/share/selections/$token'
    | '/admin/'
    | '/admin/accounts/$id'
    | '/projects/$id/selections'
    | '/settings/account/notifications'
    | '/settings/dev/demos'
    | '/settings/dev/jwt'
    | '/settings/projects/archived'
    | '/settings/users/$id'
    | '/projects/$id/'
    | '/settings/account/profile/$'
    | '/settings/dev/demos/avatar-fallbacks'
    | '/settings/dev/demos/brand'
    | '/settings/dev/demos/places-autocomplete'
    | '/settings/account/profile/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dashboard'
    | '/dev'
    | '/settings'
    | '/invite/$token'
    | '/q/$token'
    | '/share/sample'
    | '/sign-in/$'
    | '/sign-up/$'
    | '/admin/debug'
    | '/admin/deletions'
    | '/admin/design'
    | '/dev/demos'
    | '/interior-packages/$id'
    | '/settings/account'
    | '/settings/billing'
    | '/settings/clients'
    | '/settings/company'
    | '/settings/general'
    | '/settings/interior-packages'
    | '/settings/material-library'
    | '/settings/projects'
    | '/settings/qr-sheets'
    | '/settings/templates'
    | '/settings/users'
    | '/print/projects/$projectId'
    | '/print/token/$token'
    | '/share/selections/$token'
    | '/admin'
    | '/admin/accounts/$id'
    | '/projects/$id/selections'
    | '/settings/account/notifications'
    | '/settings/dev/demos'
    | '/settings/dev/jwt'
    | '/settings/projects/archived'
    | '/settings/users/$id'
    | '/projects/$id'
    | '/settings/account/profile/$'
    | '/settings/dev/demos/avatar-fallbacks'
    | '/settings/dev/demos/brand'
    | '/settings/dev/demos/places-autocomplete'
    | '/settings/account/profile'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/_authenticated/admin'
    | '/_authenticated/dashboard'
    | '/_authenticated/dev'
    | '/_authenticated/settings'
    | '/invite/$token'
    | '/q/$token'
    | '/share/sample'
    | '/sign-in/$'
    | '/sign-up/$'
    | '/_authenticated/admin/debug'
    | '/_authenticated/admin/deletions'
    | '/_authenticated/admin/design'
    | '/_authenticated/dev/demos'
    | '/_authenticated/interior-packages/$id'
    | '/_authenticated/settings/account'
    | '/_authenticated/settings/billing'
    | '/_authenticated/settings/clients'
    | '/_authenticated/settings/company'
    | '/_authenticated/settings/general'
    | '/_authenticated/settings/interior-packages'
    | '/_authenticated/settings/material-library'
    | '/_authenticated/settings/projects'
    | '/_authenticated/settings/qr-sheets'
    | '/_authenticated/settings/templates'
    | '/_authenticated/settings/users'
    | '/print/projects/$projectId'
    | '/print/token/$token'
    | '/share/selections/$token'
    | '/_authenticated/admin/'
    | '/_authenticated/admin/accounts/$id'
    | '/_authenticated/projects/$id/selections'
    | '/_authenticated/settings/account/notifications'
    | '/_authenticated/settings/dev/demos'
    | '/_authenticated/settings/dev/jwt'
    | '/_authenticated/settings/projects/archived'
    | '/_authenticated/settings/users/$id'
    | '/_authenticated/projects/$id/'
    | '/_authenticated/settings/account/profile/$'
    | '/_authenticated/settings/dev/demos/avatar-fallbacks'
    | '/_authenticated/settings/dev/demos/brand'
    | '/_authenticated/settings/dev/demos/places-autocomplete'
    | '/_authenticated/settings/account/profile/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  InviteTokenRoute: typeof InviteTokenRoute
  QTokenRoute: typeof QTokenRoute
  ShareSampleRoute: typeof ShareSampleRoute
  SignInSplatRoute: typeof SignInSplatRoute
  SignUpSplatRoute: typeof SignUpSplatRoute
  PrintProjectsProjectIdRoute: typeof PrintProjectsProjectIdRoute
  PrintTokenTokenRoute: typeof PrintTokenTokenRoute
  ShareSelectionsTokenRoute: typeof ShareSelectionsTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/admin': {
      id: '/_authenticated/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedAdminRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dev': {
      id: '/_authenticated/dev'
      path: '/dev'
      fullPath: '/dev'
      preLoaderRoute: typeof AuthenticatedDevRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/q/$token': {
      id: '/q/$token'
      path: '/q/$token'
      fullPath: '/q/$token'
      preLoaderRoute: typeof QTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/share/sample': {
      id: '/share/sample'
      path: '/share/sample'
      fullPath: '/share/sample'
      preLoaderRoute: typeof ShareSampleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in/$': {
      id: '/sign-in/$'
      path: '/sign-in/$'
      fullPath: '/sign-in/$'
      preLoaderRoute: typeof SignInSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up/$': {
      id: '/sign-up/$'
      path: '/sign-up/$'
      fullPath: '/sign-up/$'
      preLoaderRoute: typeof SignUpSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/admin/': {
      id: '/_authenticated/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthenticatedAdminIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/debug': {
      id: '/_authenticated/admin/debug'
      path: '/debug'
      fullPath: '/admin/debug'
      preLoaderRoute: typeof AuthenticatedAdminDebugRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/deletions': {
      id: '/_authenticated/admin/deletions'
      path: '/deletions'
      fullPath: '/admin/deletions'
      preLoaderRoute: typeof AuthenticatedAdminDeletionsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/design': {
      id: '/_authenticated/admin/design'
      path: '/design'
      fullPath: '/admin/design'
      preLoaderRoute: typeof AuthenticatedAdminDesignRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/dev/demos': {
      id: '/_authenticated/dev/demos'
      path: '/demos'
      fullPath: '/dev/demos'
      preLoaderRoute: typeof AuthenticatedDevDemosRouteImport
      parentRoute: typeof AuthenticatedDevRoute
    }
    '/_authenticated/interior-packages/$id': {
      id: '/_authenticated/interior-packages/$id'
      path: '/interior-packages/$id'
      fullPath: '/interior-packages/$id'
      preLoaderRoute: typeof AuthenticatedInteriorPackagesIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/account': {
      id: '/_authenticated/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof AuthenticatedSettingsAccountRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/billing': {
      id: '/_authenticated/settings/billing'
      path: '/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof AuthenticatedSettingsBillingRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/clients': {
      id: '/_authenticated/settings/clients'
      path: '/clients'
      fullPath: '/settings/clients'
      preLoaderRoute: typeof AuthenticatedSettingsClientsRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/company': {
      id: '/_authenticated/settings/company'
      path: '/company'
      fullPath: '/settings/company'
      preLoaderRoute: typeof AuthenticatedSettingsCompanyRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/general': {
      id: '/_authenticated/settings/general'
      path: '/general'
      fullPath: '/settings/general'
      preLoaderRoute: typeof AuthenticatedSettingsGeneralRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/interior-packages': {
      id: '/_authenticated/settings/interior-packages'
      path: '/interior-packages'
      fullPath: '/settings/interior-packages'
      preLoaderRoute: typeof AuthenticatedSettingsInteriorPackagesRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/material-library': {
      id: '/_authenticated/settings/material-library'
      path: '/material-library'
      fullPath: '/settings/material-library'
      preLoaderRoute: typeof AuthenticatedSettingsMaterialLibraryRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/projects': {
      id: '/_authenticated/settings/projects'
      path: '/projects'
      fullPath: '/settings/projects'
      preLoaderRoute: typeof AuthenticatedSettingsProjectsRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/qr-sheets': {
      id: '/_authenticated/settings/qr-sheets'
      path: '/qr-sheets'
      fullPath: '/settings/qr-sheets'
      preLoaderRoute: typeof AuthenticatedSettingsQrSheetsRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/templates': {
      id: '/_authenticated/settings/templates'
      path: '/templates'
      fullPath: '/settings/templates'
      preLoaderRoute: typeof AuthenticatedSettingsTemplatesRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/users': {
      id: '/_authenticated/settings/users'
      path: '/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof AuthenticatedSettingsUsersRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/print/projects/$projectId': {
      id: '/print/projects/$projectId'
      path: '/print/projects/$projectId'
      fullPath: '/print/projects/$projectId'
      preLoaderRoute: typeof PrintProjectsProjectIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/print/token/$token': {
      id: '/print/token/$token'
      path: '/print/token/$token'
      fullPath: '/print/token/$token'
      preLoaderRoute: typeof PrintTokenTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/share/selections/$token': {
      id: '/share/selections/$token'
      path: '/share/selections/$token'
      fullPath: '/share/selections/$token'
      preLoaderRoute: typeof ShareSelectionsTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/admin/accounts/$id': {
      id: '/_authenticated/admin/accounts/$id'
      path: '/accounts/$id'
      fullPath: '/admin/accounts/$id'
      preLoaderRoute: typeof AuthenticatedAdminAccountsIdRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/projects/$id/': {
      id: '/_authenticated/projects/$id/'
      path: '/projects/$id'
      fullPath: '/projects/$id/'
      preLoaderRoute: typeof AuthenticatedProjectsIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/projects/$id/selections': {
      id: '/_authenticated/projects/$id/selections'
      path: '/projects/$id/selections'
      fullPath: '/projects/$id/selections'
      preLoaderRoute: typeof AuthenticatedProjectsIdSelectionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/account/notifications': {
      id: '/_authenticated/settings/account/notifications'
      path: '/notifications'
      fullPath: '/settings/account/notifications'
      preLoaderRoute: typeof AuthenticatedSettingsAccountNotificationsRouteImport
      parentRoute: typeof AuthenticatedSettingsAccountRoute
    }
    '/_authenticated/settings/dev/demos': {
      id: '/_authenticated/settings/dev/demos'
      path: '/dev/demos'
      fullPath: '/settings/dev/demos'
      preLoaderRoute: typeof AuthenticatedSettingsDevDemosRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/dev/jwt': {
      id: '/_authenticated/settings/dev/jwt'
      path: '/dev/jwt'
      fullPath: '/settings/dev/jwt'
      preLoaderRoute: typeof AuthenticatedSettingsDevJwtRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/projects/archived': {
      id: '/_authenticated/settings/projects/archived'
      path: '/archived'
      fullPath: '/settings/projects/archived'
      preLoaderRoute: typeof AuthenticatedSettingsProjectsArchivedRouteImport
      parentRoute: typeof AuthenticatedSettingsProjectsRoute
    }
    '/_authenticated/settings/users/$id': {
      id: '/_authenticated/settings/users/$id'
      path: '/$id'
      fullPath: '/settings/users/$id'
      preLoaderRoute: typeof AuthenticatedSettingsUsersIdRouteImport
      parentRoute: typeof AuthenticatedSettingsUsersRoute
    }
    '/_authenticated/settings/account/profile/': {
      id: '/_authenticated/settings/account/profile/'
      path: '/profile'
      fullPath: '/settings/account/profile/'
      preLoaderRoute: typeof AuthenticatedSettingsAccountProfileIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsAccountRoute
    }
    '/_authenticated/settings/account/profile/$': {
      id: '/_authenticated/settings/account/profile/$'
      path: '/profile/$'
      fullPath: '/settings/account/profile/$'
      preLoaderRoute: typeof AuthenticatedSettingsAccountProfileSplatRouteImport
      parentRoute: typeof AuthenticatedSettingsAccountRoute
    }
    '/_authenticated/settings/dev/demos/avatar-fallbacks': {
      id: '/_authenticated/settings/dev/demos/avatar-fallbacks'
      path: '/avatar-fallbacks'
      fullPath: '/settings/dev/demos/avatar-fallbacks'
      preLoaderRoute: typeof AuthenticatedSettingsDevDemosAvatarFallbacksRouteImport
      parentRoute: typeof AuthenticatedSettingsDevDemosRoute
    }
    '/_authenticated/settings/dev/demos/brand': {
      id: '/_authenticated/settings/dev/demos/brand'
      path: '/brand'
      fullPath: '/settings/dev/demos/brand'
      preLoaderRoute: typeof AuthenticatedSettingsDevDemosBrandRouteImport
      parentRoute: typeof AuthenticatedSettingsDevDemosRoute
    }
    '/_authenticated/settings/dev/demos/places-autocomplete': {
      id: '/_authenticated/settings/dev/demos/places-autocomplete'
      path: '/places-autocomplete'
      fullPath: '/settings/dev/demos/places-autocomplete'
      preLoaderRoute: typeof AuthenticatedSettingsDevDemosPlacesAutocompleteRouteImport
      parentRoute: typeof AuthenticatedSettingsDevDemosRoute
    }
  }
}

interface AuthenticatedAdminRouteChildren {
  AuthenticatedAdminDebugRoute: typeof AuthenticatedAdminDebugRoute
  AuthenticatedAdminDeletionsRoute: typeof AuthenticatedAdminDeletionsRoute
  AuthenticatedAdminDesignRoute: typeof AuthenticatedAdminDesignRoute
  AuthenticatedAdminIndexRoute: typeof AuthenticatedAdminIndexRoute
  AuthenticatedAdminAccountsIdRoute: typeof AuthenticatedAdminAccountsIdRoute
}

const AuthenticatedAdminRouteChildren: AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminDebugRoute: AuthenticatedAdminDebugRoute,
  AuthenticatedAdminDeletionsRoute: AuthenticatedAdminDeletionsRoute,
  AuthenticatedAdminDesignRoute: AuthenticatedAdminDesignRoute,
  AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute,
  AuthenticatedAdminAccountsIdRoute: AuthenticatedAdminAccountsIdRoute,
}

const AuthenticatedAdminRouteWithChildren =
  AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)

interface AuthenticatedDevRouteChildren {
  AuthenticatedDevDemosRoute: typeof AuthenticatedDevDemosRoute
}

const AuthenticatedDevRouteChildren: AuthenticatedDevRouteChildren = {
  AuthenticatedDevDemosRoute: AuthenticatedDevDemosRoute,
}

const AuthenticatedDevRouteWithChildren =
  AuthenticatedDevRoute._addFileChildren(AuthenticatedDevRouteChildren)

interface AuthenticatedSettingsAccountRouteChildren {
  AuthenticatedSettingsAccountNotificationsRoute: typeof AuthenticatedSettingsAccountNotificationsRoute
  AuthenticatedSettingsAccountProfileSplatRoute: typeof AuthenticatedSettingsAccountProfileSplatRoute
  AuthenticatedSettingsAccountProfileIndexRoute: typeof AuthenticatedSettingsAccountProfileIndexRoute
}

const AuthenticatedSettingsAccountRouteChildren: AuthenticatedSettingsAccountRouteChildren =
  {
    AuthenticatedSettingsAccountNotificationsRoute:
      AuthenticatedSettingsAccountNotificationsRoute,
    AuthenticatedSettingsAccountProfileSplatRoute:
      AuthenticatedSettingsAccountProfileSplatRoute,
    AuthenticatedSettingsAccountProfileIndexRoute:
      AuthenticatedSettingsAccountProfileIndexRoute,
  }

const AuthenticatedSettingsAccountRouteWithChildren =
  AuthenticatedSettingsAccountRoute._addFileChildren(
    AuthenticatedSettingsAccountRouteChildren,
  )

interface AuthenticatedSettingsProjectsRouteChildren {
  AuthenticatedSettingsProjectsArchivedRoute: typeof AuthenticatedSettingsProjectsArchivedRoute
}

const AuthenticatedSettingsProjectsRouteChildren: AuthenticatedSettingsProjectsRouteChildren =
  {
    AuthenticatedSettingsProjectsArchivedRoute:
      AuthenticatedSettingsProjectsArchivedRoute,
  }

const AuthenticatedSettingsProjectsRouteWithChildren =
  AuthenticatedSettingsProjectsRoute._addFileChildren(
    AuthenticatedSettingsProjectsRouteChildren,
  )

interface AuthenticatedSettingsUsersRouteChildren {
  AuthenticatedSettingsUsersIdRoute: typeof AuthenticatedSettingsUsersIdRoute
}

const AuthenticatedSettingsUsersRouteChildren: AuthenticatedSettingsUsersRouteChildren =
  {
    AuthenticatedSettingsUsersIdRoute: AuthenticatedSettingsUsersIdRoute,
  }

const AuthenticatedSettingsUsersRouteWithChildren =
  AuthenticatedSettingsUsersRoute._addFileChildren(
    AuthenticatedSettingsUsersRouteChildren,
  )

interface AuthenticatedSettingsDevDemosRouteChildren {
  AuthenticatedSettingsDevDemosAvatarFallbacksRoute: typeof AuthenticatedSettingsDevDemosAvatarFallbacksRoute
  AuthenticatedSettingsDevDemosBrandRoute: typeof AuthenticatedSettingsDevDemosBrandRoute
  AuthenticatedSettingsDevDemosPlacesAutocompleteRoute: typeof AuthenticatedSettingsDevDemosPlacesAutocompleteRoute
}

const AuthenticatedSettingsDevDemosRouteChildren: AuthenticatedSettingsDevDemosRouteChildren =
  {
    AuthenticatedSettingsDevDemosAvatarFallbacksRoute:
      AuthenticatedSettingsDevDemosAvatarFallbacksRoute,
    AuthenticatedSettingsDevDemosBrandRoute:
      AuthenticatedSettingsDevDemosBrandRoute,
    AuthenticatedSettingsDevDemosPlacesAutocompleteRoute:
      AuthenticatedSettingsDevDemosPlacesAutocompleteRoute,
  }

const AuthenticatedSettingsDevDemosRouteWithChildren =
  AuthenticatedSettingsDevDemosRoute._addFileChildren(
    AuthenticatedSettingsDevDemosRouteChildren,
  )

interface AuthenticatedSettingsRouteChildren {
  AuthenticatedSettingsAccountRoute: typeof AuthenticatedSettingsAccountRouteWithChildren
  AuthenticatedSettingsBillingRoute: typeof AuthenticatedSettingsBillingRoute
  AuthenticatedSettingsClientsRoute: typeof AuthenticatedSettingsClientsRoute
  AuthenticatedSettingsCompanyRoute: typeof AuthenticatedSettingsCompanyRoute
  AuthenticatedSettingsGeneralRoute: typeof AuthenticatedSettingsGeneralRoute
  AuthenticatedSettingsInteriorPackagesRoute: typeof AuthenticatedSettingsInteriorPackagesRoute
  AuthenticatedSettingsMaterialLibraryRoute: typeof AuthenticatedSettingsMaterialLibraryRoute
  AuthenticatedSettingsProjectsRoute: typeof AuthenticatedSettingsProjectsRouteWithChildren
  AuthenticatedSettingsQrSheetsRoute: typeof AuthenticatedSettingsQrSheetsRoute
  AuthenticatedSettingsTemplatesRoute: typeof AuthenticatedSettingsTemplatesRoute
  AuthenticatedSettingsUsersRoute: typeof AuthenticatedSettingsUsersRouteWithChildren
  AuthenticatedSettingsDevDemosRoute: typeof AuthenticatedSettingsDevDemosRouteWithChildren
  AuthenticatedSettingsDevJwtRoute: typeof AuthenticatedSettingsDevJwtRoute
}

const AuthenticatedSettingsRouteChildren: AuthenticatedSettingsRouteChildren = {
  AuthenticatedSettingsAccountRoute:
    AuthenticatedSettingsAccountRouteWithChildren,
  AuthenticatedSettingsBillingRoute: AuthenticatedSettingsBillingRoute,
  AuthenticatedSettingsClientsRoute: AuthenticatedSettingsClientsRoute,
  AuthenticatedSettingsCompanyRoute: AuthenticatedSettingsCompanyRoute,
  AuthenticatedSettingsGeneralRoute: AuthenticatedSettingsGeneralRoute,
  AuthenticatedSettingsInteriorPackagesRoute:
    AuthenticatedSettingsInteriorPackagesRoute,
  AuthenticatedSettingsMaterialLibraryRoute:
    AuthenticatedSettingsMaterialLibraryRoute,
  AuthenticatedSettingsProjectsRoute:
    AuthenticatedSettingsProjectsRouteWithChildren,
  AuthenticatedSettingsQrSheetsRoute: AuthenticatedSettingsQrSheetsRoute,
  AuthenticatedSettingsTemplatesRoute: AuthenticatedSettingsTemplatesRoute,
  AuthenticatedSettingsUsersRoute: AuthenticatedSettingsUsersRouteWithChildren,
  AuthenticatedSettingsDevDemosRoute:
    AuthenticatedSettingsDevDemosRouteWithChildren,
  AuthenticatedSettingsDevJwtRoute: AuthenticatedSettingsDevJwtRoute,
}

const AuthenticatedSettingsRouteWithChildren =
  AuthenticatedSettingsRoute._addFileChildren(
    AuthenticatedSettingsRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedAdminRoute: typeof AuthenticatedAdminRouteWithChildren
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedDevRoute: typeof AuthenticatedDevRouteWithChildren
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRouteWithChildren
  AuthenticatedInteriorPackagesIdRoute: typeof AuthenticatedInteriorPackagesIdRoute
  AuthenticatedProjectsIdSelectionsRoute: typeof AuthenticatedProjectsIdSelectionsRoute
  AuthenticatedProjectsIdIndexRoute: typeof AuthenticatedProjectsIdIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedDevRoute: AuthenticatedDevRouteWithChildren,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRouteWithChildren,
  AuthenticatedInteriorPackagesIdRoute: AuthenticatedInteriorPackagesIdRoute,
  AuthenticatedProjectsIdSelectionsRoute:
    AuthenticatedProjectsIdSelectionsRoute,
  AuthenticatedProjectsIdIndexRoute: AuthenticatedProjectsIdIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  InviteTokenRoute: InviteTokenRoute,
  QTokenRoute: QTokenRoute,
  ShareSampleRoute: ShareSampleRoute,
  SignInSplatRoute: SignInSplatRoute,
  SignUpSplatRoute: SignUpSplatRoute,
  PrintProjectsProjectIdRoute: PrintProjectsProjectIdRoute,
  PrintTokenTokenRoute: PrintTokenTokenRoute,
  ShareSelectionsTokenRoute: ShareSelectionsTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
